import React from "react";

import { TabContainer, Tab } from "shared/TabContainer";

import Table from "shared/Table";
import DataList, { DataRow } from "shared/DataList";

import { Empty } from "..";

export const tabs = {
  details: "details",
  fma: "fma",
  consolidated: "consolidated",
  notes: "notes",
};

export default function ({ selectedTab, onTabChange, transaction }) {
  const details = transaction.details || {};
  const consolidatedBilling = transaction.consolidatedBilling || [];

  return (
    <TabContainer value={selectedTab} onTabChange={onTabChange}>
      <Tab title="Details" value={tabs.details}>
        <DataList>
          <DataRow label="Transaction ID">{details.tranId}</DataRow>
          <DataRow label="Status">{details.status}</DataRow>
          <DataRow label="Merchant">{details.merchant || <Empty />}</DataRow>
          <DataRow label="Amount Actually Paid">
            {details.amountActuallyPaid}
          </DataRow>
          <DataRow label="Membership Fee">{details.membershipFee}</DataRow>
          <DataRow label="Billed To">{details.billedTo}</DataRow>
          <DataRow label="Notes">{transaction.notes || <Empty />}</DataRow>
        </DataList>
      </Tab>

      <Tab title="FMA" value={tabs.fma}>
        <DataList>
          <DataRow label="Amount">
            <Empty />
          </DataRow>
          <DataRow label="FMA ID">
            <Empty />
          </DataRow>
          <DataRow label="Stock ID">
            <Empty />
          </DataRow>
          <DataRow label="Title">
            <Empty />
          </DataRow>
        </DataList>
      </Tab>

      <Tab title="Consolidated" value={tabs.consolidated}>
        <Table>
          <thead>
            <tr>
              <th>Type</th>
              <th>Transaction ID</th>
              <th>Amount</th>
              <th>Total</th>
            </tr>
          </thead>
          <tbody>
            {consolidatedBilling.map((record, i) => (
              <tr key={i}>
                <td>{record.type}</td>
                <td>{record.tranId}</td>
                <td>{record.amount}</td>
                <td>
                  <strong>{record.cnsAmount}</strong>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      </Tab>
    </TabContainer>
  );
}
